<ion-textarea
  [class.required]="required"
  [placeholder]="placeholder"
  [label]="label"
  [labelPlacement]="labelPlacement"
  [helperText]="helperText"
  [required]="required"
  [inputmode]="inputmode"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [name]="name"
  [debounce]="debounce"
  [readonly]="readonly"
  [disabled]="disabled"
  [autoGrow]="autoGrow"
  [rows]="rows"
  [attr.autocapitalize]="autocapitalize"
  [attr.autocorrect]="autocorrect"
  [attr.autocomplete]="autocomplete"
  [attr.enterkeyhint]="enterkeyhint"
  [spellcheck]="spellcheck"
  [value]="currentValue"
  (ionInput)="handleInput($event)"
  (ionChange)="ionChange.emit($event)"
  (ionBlur)="handleBlur($event)"
  (ionFocus)="ionFocus.emit($event)"
>
  <ng-content></ng-content>
</ion-textarea>
